import {
  Field,
  withDatasourceCheck,
  Item,
  getFieldValue,
  Text,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import { ComponentProps } from 'lib/component-props';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';
import { RecordOfFields } from 'models/fields';

import styles from './Listings.module.scss';
import ToutListingCard, { type ToutCardFields } from './ToutListingCard';

type ToutListingFields = {
  children: Item[];
  heading: Field<string>;
  headingLevel: Item;
  headingTextStyle: Item | null;
};

type ToutListingProps = ComponentProps & {
  fields: ToutListingFields;
};

const cx = classNames.bind(styles);

const ThreeColumnToutListing = (props: ToutListingProps): JSX.Element => {
  const { className, fields } = props;
  const { children, heading, headingLevel, headingTextStyle } = fields;
  const { sitecoreContext } = useSitecoreContext();
  const headLvl = getFieldValue<string>(headingLevel?.fields as RecordOfFields, 'Value') || 'h2';

  const titleTextStyleItemField = headingTextStyle?.fields as RecordOfFields;
  const titleTextStyleValue = getFieldValue<string>(titleTextStyleItemField, 'Value') || 'font-style-xl';

  const toutCards = children?.map((item, i) => {
    return <ToutListingCard key={i} fields={item.fields as ToutCardFields} />;
  });

  const resultsRender = [];
  let cardList = [];
  for (let x = 0; x < toutCards.length; x++) {
    cardList.push(toutCards[x]);
    if ((x % 3 === 2 || x === toutCards.length - 1) && cardList.length > 0) {
      resultsRender.push(
        <div key={x} className={cx('tout-container')}>
          {cardList}
        </div>
      );
      cardList = [];
    }
  }

  return (
    <div className={cx('tout-center', className)}>
      <Text className={cx(titleTextStyleValue)} encode={sitecoreContext.pageEditing} field={heading} tag={headLvl} />
      {resultsRender}
    </div>
  );
};

export default compose<ToutListingProps>(withDatasourceCheck(), withStyles())(ThreeColumnToutListing);
